import { render, staticRenderFns } from "./events_index.vue?vue&type=template&id=030be3cc&"
import script from "./events_index.vue?vue&type=script&lang=js&"
export * from "./events_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports